'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import { Button } from '~/components/Button';
import type { ItineraryCardChangeFieldProps } from './ItineraryCard.types';
import styles from './ItineraryCardChangeField.module.css';
export function ItineraryCardChangeField(t0) {
  const $ = _c(22);
  const {
    label,
    value,
    buttonLabel,
    testId,
    onPress,
    onPrefetch,
    helpIcon,
    isDisabled,
    isValueSubtext
  } = t0;
  const t = useTranslations("journey");
  let t1;
  if ($[0] !== label || $[1] !== testId) {
    t1 = testId ?? (label ? `change-${label.toLowerCase().replace(/\s+/g, "-")}` : undefined);
    $[0] = label;
    $[1] = testId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const dataTestId = t1;
  let t2;
  if ($[3] !== label) {
    t2 = label && <span className={styles.label}>{label}</span>;
    $[3] = label;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== helpIcon || $[6] !== isValueSubtext || $[7] !== value) {
    t3 = value && <div className={styles.valueRow}><span className={clsx(styles.value, isValueSubtext && styles.valueSubtext)}>{value}</span>{helpIcon}</div>;
    $[5] = helpIcon;
    $[6] = isValueSubtext;
    $[7] = value;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <div className={styles.content}>{t2}{t3}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== buttonLabel || $[13] !== dataTestId || $[14] !== isDisabled || $[15] !== onPrefetch || $[16] !== onPress || $[17] !== t) {
    t5 = onPress && <span className={styles.changeButtonWrap}><Button variant="bare" onPress={onPress} isDisabled={isDisabled} onHoverStart={onPrefetch} onFocus={onPrefetch} dataTestId={dataTestId}>{buttonLabel ?? t("itinerary_change_button")}</Button></span>;
    $[12] = buttonLabel;
    $[13] = dataTestId;
    $[14] = isDisabled;
    $[15] = onPrefetch;
    $[16] = onPress;
    $[17] = t;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t4 || $[20] !== t5) {
    t6 = <div className={styles.field}>{t4}{t5}</div>;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
}